// extracted by mini-css-extract-plugin
module.exports = {"form":"Check_form__3upfh","message":"Check_message__MV0HC"};